import { authHttp } from '../http'
import { downloadErrorHandler, errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/delivery`

const CicloEntregaAcoesHttp = {
  async enviarEmail(ciclo_id, email_ids) {
    try {
      const url = BASE_URL + '/ciclo-entrega-acao/enviar-email'
      await authHttp().post(url, { ciclo_id, email_ids })
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async getProgramacaoEntrega(ciclo_id) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/exportar-programacao-entrega/${ciclo_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async getRevisaoDataProgramacao(ciclo_id) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/revisao-data-programacao/${ciclo_id}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async updateDataProgramacao(info) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/atualizar-data-programacao`
      await authHttp().put(url, info)
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async getPlacaPreviaCarregamento(cicloId, selectedTp) {
    try {
      const url =
        BASE_URL + `/ciclo-entrega-acao/placa-previa-carregamento/${cicloId}/${selectedTp}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async trocarPlaca({ deliveriesIds, placa_destino }) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/trocar-placa`
      await authHttp().post(url, {
        deliveries_ids: deliveriesIds,
        placa_destino,
      })
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getEntregasByCicloId(cicloId) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/entregas-por-ciclo/${cicloId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getEtiquetagemVolumesByCicloId(cicloId) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/etiquetagem-volumes-por-ciclo/${cicloId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  urlReportEtiquetaVolumesEntrega(deliveryIds) {
    const token = localStorage.getItem('t')
    return (
      BASE_URL +
      `/ciclo-entrega-acao/report-etiqueta-volumes-entrega?delivery_ids=${deliveryIds.join(',')}&t=${token}`
    )
  },

  urlEspelhoNota(cicloId) {
    const token = localStorage.getItem('t')
    const url = BASE_URL + `/ciclo-entrega-acao/espelho-nota/${cicloId}?t=${token}`
    return url
  },

  async downloadMapaPesoCidade(cicloId) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/mapa-peso-cidade/${cicloId}`
      const response = await authHttp().get(url, {
        responseType: 'blob',
      })
      return response.data
    } catch (error) {
      throw await downloadErrorHandler(error)
    }
  },

  async getDeliveryItemsByDeliveryId(deliveryId) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/delivery-items-by-delivery/${deliveryId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateDeliveriesItems(deliveryItems) {
    // {delivery_item_id, qte_sku}
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/update-delivery-items`
      const response = await authHttp().put(url, deliveryItems)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateDeliveryItemObservacao(payload) {
    try {
      const url = BASE_URL + `/ciclo-entrega-acao/update-delivery-item-observacao`
      const response = await authHttp().put(url, payload)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async downloadCanhoto(imageUrl) {
    try {
      const response = await authHttp().get(
        BASE_URL + '/canhoto/download',
        {
          params: { url: imageUrl },
          responseType: 'blob',
        },
      )

      return response.data
    } catch (error) {
      throw error
    }
  },

  async downloadCanhotos(deliveryIds, user_id) {
    try {
      const response = await authHttp().post(
        BASE_URL + '/canhotos/download',
        { delivery_ids: deliveryIds, user_id },
        {
          responseType: 'json',
        },
      )

      console.log(response.data)

      // const blob = new Blob([response.data], { type: 'application/zip' })

      // const url = window.URL.createObjectURL(blob)
      // const link = document.createElement('a')
      // link.href = url
      // link.setAttribute('download', 'canhotos.zip')

      // document.body.appendChild(link)
      // link.click()

      // link.parentNode.removeChild(link)
      // window.URL.revokeObjectURL(url)
      return response.data
    } catch (error) {
      throw error
    }
  },

  async getDeliveryItemsByCycle(cycleId) {
    try {
      const url = `${BASE_URL}/ciclo-entrega-acao/delivery-items-by-cycle/${cycleId}`
      const { data } = await authHttp().get(url)
      return data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async saveEntradaSif(items) {
    try {
      const url = BASE_URL + '/ciclo-entrega-acao/update-entrada-sif'
      await authHttp().put(url, { items })
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default CicloEntregaAcoesHttp
